import { useEmployeeAuth } from "./AdminProvider";

export function AdminLogout(){
    const auth = useEmployeeAuth()
    auth.logout()
    
}